<template>
  <LoaderComponent v-if="loadingData"></LoaderComponent>
  <div v-if="!showDetail" >
    <SearchCategoryComponent :lang="currentLang" @search="onSearch" @clear="onClear" @clear-result="onClearResult" @error="onError"></SearchCategoryComponent>
    <div style="margin-top: 10px;" v-if="resultSearch">
      <FoodAdvancedResult :resultData="resultSearch" :columns="columns" :lang="currentLang" @selectFood="onSelectFood"></FoodAdvancedResult>
    </div>
  </div>
  <div  >
    <FoodComponent v-if="showDetail" :id="currentFoodId" :language="currentLang" @back="onBack" @error="onError"></FoodComponent>
  </div>
  <MessageComponent v-if="message!=''" :message="message" :messageType="messagetype"></MessageComponent>
</template>

<script>
import { app } from "../main.js";
import api from "../js/apiConsts.js";
import apiConsts from "../js/apiConsts.js";
import { getSTRING } from "@/js/utils";
import { axiosPost } from "../js/apiService.js";
import LoaderComponent from "@/components/LoaderComponent.vue";
import SearchCategoryComponent from "@/components/SearchCategoryComponent.vue";
import FoodAdvancedResult from "@/components/FoodAdvancedResult.vue";
import FoodComponent from "@/components/FoodComponent.vue";
import MessageComponent from "@/components/MessageComponent.vue";
export default {
  name: "PageFoodByComponent",
  components: {
    SearchCategoryComponent,
    LoaderComponent,
    FoodAdvancedResult,
    FoodComponent,
    MessageComponent
  },
  data() {
    return {
      currentLang: this.$route.params.lang,
      resultSearch: null,
      columns: null,
      loadingData: false,
      showDetail: false,
      currentFoodId: null,
      TITOLO: '',
      message: '',
      messagetype: 1
    };
  },
  mounted() {
    this.TITOLO = getSTRING(this.currentLang, "TITOLO", apiConsts.TITOLOAPP)
  },
  unmounted() {
    app.config.globalProperties.$GenericError = false;
  },
  methods: {
    onClear() {
      this.resultSearch = null;
      this.columns = null;
      this.message = '';
    },
    onClearResult() {
      this.resultSearch = null;
      this.columns = null;      
    },
    onError(message) {
      this.message=message;
    },
    async onSearch(reverseItems, itemsToSearch, groupsToSearch) {
      this.message='';
      let language = this.currentLang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1;
      this.loadingData = true;
      await axiosPost(api.APISearchFoodAdvanced, {
        language: language,
        reverse: reverseItems,
        components: itemsToSearch,
        categories: groupsToSearch
      })
        .then((response) => {
          let res = response.data;
          this.resultSearch = null;
          this.columns = null;
          this.loadingData = false;
          if (res.success) {
            this.resultSearch = res.foods;
            this.columns = res.columns;
          } else {
            this.message=res.message;
          }
        })
        .catch((err) => {
          this.loadingData = false;
          this.message=err.message;
        });
    },
    onSelectFood(food) {
      this.showDetail = true;
      this.currentFoodId = food.idFood;
    },
    onBack() {
      this.showDetail = false;
      this.currentFoodId = null;
    }
  }
};
</script>

<style></style>